/** "No results found" magnifier illustration, shared by filtered-empty table states. */
const NoSearchResultSvg = () => {
    return (
        <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_no_search_result)">
                <path
                    d="M135.973 128.608L100.426 93.0616C107.311 84.5566 111.457 73.7493 111.457 61.9787C111.457 34.6978 89.2594 12.5 61.9785 12.5C34.6975 12.5 12.5 34.6975 12.5 61.9785C12.5 89.2594 34.6978 111.457 61.9787 111.457C73.7493 111.457 84.5566 107.311 93.0616 100.426L128.608 135.973C129.624 136.988 130.957 137.499 132.29 137.499C133.624 137.499 134.957 136.988 135.973 135.973C138.009 133.936 138.009 130.644 135.973 128.608ZM61.9787 101.041C40.4372 101.041 22.9166 83.52 22.9166 61.9785C22.9166 40.4369 40.4372 22.9164 61.9787 22.9164C83.5202 22.9164 101.041 40.4369 101.041 61.9785C101.041 83.52 83.52 101.041 61.9787 101.041Z"
                    fill="#DDE6F3"
                />
                <g clipPath="url(#clip1_no_search_result)">
                    <path
                        d="M48.0296 78.3482C47.154 78.3991 46.2929 78.108 45.6278 77.5363C44.3161 76.2168 44.3161 74.0858 45.6278 72.7664L74.3484 44.0457C75.7126 42.7691 77.8533 42.8401 79.1299 44.2043C80.2842 45.4379 80.3515 47.3341 79.2874 48.6464L50.3975 77.5363C49.7411 78.0997 48.8937 78.3903 48.0296 78.3482Z"
                        fill="#DDE6F3"
                    />
                    <path
                        d="M76.7172 78.3477C75.8297 78.3439 74.9792 77.9916 74.3491 77.3667L45.6284 48.6458C44.4132 47.2268 44.5784 45.0912 45.9974 43.876C47.264 42.7913 49.1318 42.7913 50.3982 43.876L79.2881 72.5967C80.652 73.8736 80.7225 76.0144 79.4456 77.3783C79.3948 77.4325 79.3423 77.485 79.2881 77.5358C78.9381 77.8401 78.5293 78.0692 78.087 78.2089C77.6447 78.3486 77.1785 78.3958 76.7172 78.3477Z"
                        fill="#DDE6F3"
                    />
                </g>
                <g filter="url(#filter0_f_no_search_result)">
                    <ellipse cx="64.5" cy="138" rx="50" ry="4.5" fill="#DDE6F3" />
                </g>
            </g>
            <defs>
                <filter id="filter0_f_no_search_result" x="4.5" y="123.5" width="120" height="29" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur" />
                </filter>
                <clipPath id="clip0_no_search_result">
                    <rect width="150" height="150" fill="white" />
                </clipPath>
                <clipPath id="clip1_no_search_result">
                    <rect width="35.7143" height="35.7143" fill="white" transform="translate(44.6431 42.8574)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default NoSearchResultSvg;
